<template>
  <div class="tableFixHead">
    <table>
      <thead style="background-color: #fff">
        <tr>
          <th rowspan="2">STT</th>
          <th rowspan="2" data-filter-control="select" class="searchable-header">
            Số Itel
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.Phone"
              style="width: 150px"
              placeholder="Filter Số Itel"
            ></b-form-input>
          </th>
          <th rowspan="2" class="searchable-header">
            Giá bán
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.Price"
              style="width: 150px"
              placeholder="Filter Giá bán"
            ></b-form-input>
          </th>
          <th rowspan="2" class="searchable-header">
            Gói cước
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.Pack"
              style="width: 150px"
              placeholder="Filter Gói cước"
            ></b-form-input>
          </th>
          <th rowspan="2" class="searchable-header">
            Giá gói cước
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.PackPrice"
              style="width: 150px"
              placeholder="Filter Giá gói cước"
            ></b-form-input>
          </th>
          <th rowspan="2" class="searchable-header">
            Tháng cam kết
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.Months"
              style="width: 150px"
              placeholder="Filter Tháng cam kết"
            ></b-form-input>
          </th>
          <th rowspan="2" class="searchable-header">
            Trạng thái
            <br />
            <vSelect
              style="width: 260px"
              :options="filterStatusList"
              @
              v-model="serverParams.columnFilters.Status"
              placeholder="Filter Trạng thái"
              label="text"
              :reduce="(c) => c.id"
            ></vSelect>
            <!--                <b-form-input v-model="serverParams.columnFilters.Status" style="width: 150px"-->
            <!--                              placeholder="Filter Trạng thái"></b-form-input>-->
          </th>
          <th rowspan="2" class="searchable-header">
            Danh mục số
            <br />
            <vSelect
              style="width: 200px"
              :options="simCategory"
              v-model="serverParams.columnFilters.CategoryID"
              placeholder="Filter danh mục số"
              label="Name"
              :reduce="(c) => c.id"
            ></vSelect>
          </th>
          <th rowspan="2" class="searchable-header">
            Loại thuê bao
            <br />
            <vSelect
              style="width: 150px"
              :options="[
                { id: 0, text: 'Thường' },
                { id: 1, text: 'Cam kết' },
              ]"
              v-model="serverParams.columnFilters.ThueBaoCamKet"
              placeholder="Filter Loại thuê bao"
              label="text"
              :reduce="(c) => c.id"
            ></vSelect>
          </th>
          <th rowspan="2" class="searchable-header">
            Loại số
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.group_name"
              style="width: 200px"
              placeholder="Filter Loại số"
            ></b-form-input>
          </th>
          <th rowspan="2" class="searchable-header">
            Kênh
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.SaleChannels"
              style="width: 150px"
              placeholder="Filter Kênh"
            ></b-form-input>
          </th>
          <th colspan="2" class="text-center">
            Phong thủy
            <!-- <br/>
          <b-form-input  style="width: 150px" placeholder="Filter Giá bán"></b-form-input> -->
          </th>
          <th rowspan="2" class="searchable-header">
            Tag số
            <br />
            <b-form-input
              v-model="serverParams.columnFilters.tag"
              style="width: 150px"
              placeholder="Filter Tag số"
            ></b-form-input>
          </th>
          <th rowspan="2">Actions</th>
        </tr>
        <tr>
          <th>
            Mệnh
            <br />
            <vSelect
              style="width: 150px"
              :options="filterMenhList"
              v-model="serverParams.columnFilters.MenhSim"
              placeholder="Filter Mệnh"
              label="text"
              :reduce="(c) => c.id"
            ></vSelect>
            <!--                <b-form-input v-model="serverParams.columnFilters.MenhSim" style="width: 150px"-->
            <!--                              placeholder="Filter Mệnh"></b-form-input>-->
          </th>
          <th>
            Nút
            <br />
            <vSelect
              style="width: 150px"
              :options="filterSoNut"
              v-model="serverParams.columnFilters.SoNut"
              placeholder="Filter Nút"
            ></vSelect>
            <!--                <b-form-input v-model="serverParams.columnFilters.SoNut" style="width: 150px"-->
            <!--                              placeholder="Filter Nút"></b-form-input>-->
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) of dataList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.Phone }}</td>
          <td>{{ item.Price }}</td>
          <td>{{ item.Pack }}</td>
          <td>{{ item.PackPrice }}</td>
          <td>{{ item.Months }}</td>
          <td>{{ statusText[item.Status] }}</td>
          <td>
            <div v-if="item.CategoryNames">
              <p
                v-for="i in item.CategoryNames.split(',')"
                :key="i"
                class="table-item"
                style="margin-right: 0.5rem"
              >
                {{ i }}
              </p>
            </div>
          </td>
          <td>
            <span class="table-item">
              {{ item.ThueBaoCamKet === 1 ? " Cam Kết" : " Thường" }}</span
            >
          </td>
          <td>
            <span class="table-item">{{ item.group_name }}</span>
          </td>
          <td>
            <div v-if="item.SaleChannels" class="d-flex flex-column">
              <span
                v-for="i in item.SaleChannels.split(',')"
                :key="i"
                class="table-item"
                >{{ i }}</span
              >
            </div>
          </td>

          <td>
            <span :class="item.MenhSim ? 'table-item' : ''"> {{ item.MenhSim }}</span>
          </td>
          <td>
            <span :class="item.SoNut || item.SoNut == 0 ? 'table-item' : ''">
              {{ item.SoNut }}</span
            >
          </td>
          <td>
            <div v-if="item.Tags" class="d-flex flex-column">
              <span v-for="i in item.Tags.split(',')" :key="i" class="table-item">{{
                i
              }}</span>
            </div>
          </td>
          <td>
            <b-button
              variant="primary"
              class="btn-icon"
              size="sm"
              @click="Edit(item)"
              v-if="item.Status !== 20"
            >
              <feather-icon icon="Edit2Icon" />
            </b-button>
            <b-button
              v-if="item.Status == 20"
              variant="primary"
              class="btn-icon"
              size="sm"
              @click="Edit(item)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Select2 from "v-select2-component";
import {BButton, BFormInput} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  name: "SearchForMonth",
  props: {
    dataList: {
      type: Array,
      default: [],
    },
    isSeachMonth: {
      type: Boolean,
      default: true,
    },
    // serverParams: {
    //   type: Object,
    // }
  },
  mounted() {
    this.getSimCategory();
  },
  components: {
    BButton,
    BFormInput,
    vSelect,
    Select2,
  },
  data() {
    return {
      serverParams: {
        columnFilters: {},
      },
      simCategory: [],
      filterTimeout: null,
      filterStatusList: [
        { id: 0, text: "Sẵn sàng" },
        { id: 1, text: "Đã bán - chưa kích hoạt" },
        { id: 2, text: "Đã bán - đã kích hoạt" },
        { id: 10, text: "iTel giữ số" },
        { id: 11, text: "Lỗi VnPay, chờ kiểm tra" },
        { id: 99, text: "99" },
      ],
      statusText: {
        0: "Sẵn sàng",
        1: "Đã bán - chưa kích hoạt",
        2: "Đã bán - đã kích hoạt",
        10: "iTel giữ số",
        11: "Lỗi VnPay, chờ kiểm tra",
        99: "99",
        100: "100",
      },
      filterMenhList: [
        { id: "Kim", text: "Kim" },
        { id: "Mộc", text: "Mộc" },
        { id: "Thủy", text: "Thủy" },
        { id: "Hỏa", text: "Hỏa" },
        { id: "Thổ", text: "Thổ" },
      ],
      filterSoNut: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    };
  },
  watch: {
    serverParams: {
      handler(newValue) {
        clearTimeout(this.filterTimeout);
        this.filterTimeout = setTimeout(() => {
          this.$emit("onColumnFilter", newValue);
        }, 500);
      },
      deep: true,
    },
  },

  methods: {
    Edit(item) {
      this.$emit("handleActions", item);
    },
    getSimCategory() {
      useJwt.get("/get_SimCaTeGory").then((res) => {
        this.simCategory = res.data.result;
      });
    },
  },
};
</script>
<style scoped lang="scss">
table {
  border-collapse: separate;
  border-spacing: 0;
}

td,
th {
  border: 1px solid #ebe9f1;
  padding: 5px 15px;
  text-align: center;
}

.tableFixHead {
  overflow: auto;
  height: 70vh;
}

.tableFixHead thead {
  position: sticky;
  top: 0;
  z-index: 1;
  padding-bottom: 0.5rem;
}

.searchable-header {
  text-align: center;
  padding-top: 2rem;
  padding-bottom: 1rem;
}

.searchable-header input {
  margin-top: 0.5rem;
}

.searchable-header .v-select {
  margin-top: 0.5rem;
}

.table-item {
  width: fit-content;
  padding: 0.5rem;
  margin-top: 1%;
  background-color: #ed1f24;
  color: white;
  border-radius: 8px;
}

/* /* thead > tr:nth-child(1) > th:nth-child(1) { background-color: Orchid; } */
// thead > tr th { text-align: center !important; }
// tr>th:last-child,tr>td:last-child {
//     position: sticky;
//     right: 0;
//   }
//   tbody {
//         tr:nth-child(odd) td {
//             background: #fff;
//         }
//     }
</style>
